import "./valuessection.css";
import { IoHomeOutline } from "react-icons/io5";
import { GoPencil } from "react-icons/go";
import { MdOutlineLock } from "react-icons/md";
import { FaRegFlag } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { FaRegSun } from "react-icons/fa";

const values = [
  {
    icon: <IoHomeOutline />,
    title: "Honesty",
    description:
      "We value transparency and integrity in all our relationships and operations.",
  },
  {
    icon: <GoPencil />,
    title: "Learning",
    description:
      "We embrace continuous growth and encourage the pursuit of knowledge.",
  },
  {
    icon: <MdOutlineLock />,
    title: "Trust",
    description:
      "Trust is the foundation of our culture, guiding how we work and interact.",
  },
  {
    icon: <FaRegFlag />,
    title: "Passion",
    description:
      "We are passionate about our mission and dedicated to making a difference.",
  },
  {
    icon: <FaRegEye />,
    title: "Vision",
    description:
      "We envision a future led by innovation, collaboration, and purpose.",
  },
  {
    icon: <FaRegSun />,
    title: "Future",
    description:
      "We build for tomorrow with sustainability, resilience, and bold thinking.",
  },
];

export default function ValuesSection() {
  return (
    <section className="values-section">
      <p className="small-header">Our Values</p>
      <h3 className="main-title">A New Revolution, a New Perspective</h3>
      <div className="values-grid">
        {values.map((value, index) => (
          <div className="value-card" key={index}>
            <div className="icon">{value.icon}</div>
            <h4>{value.title}</h4>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
